module.exports = __webpack_public_path__ + "static/media/PS2_Miles 01.984427c1.png";